import React, {Component} from 'react'

class UnionsAndRepresentationsBox extends Component {
  constructor(props){
    super(props);
  }
  render() {
    let overviewData = this.props.overviewData;
    return (
      <div className="col-md-6 widget">
        <div className="title">Unions and representations</div>
          <div className="row">
            <div className="col-4">
              {overviewData.VoiceActorUnion && <div>Actor's union:</div>}
              {overviewData.VoiceActorAgency && <div>Actor's agency:</div>}
              {overviewData.VoiceActorAgencyContactName && <br />}
              {overviewData.VoiceActorAgencyContactEmail && <br />}
              {overviewData.VoiceActorAgencyContactPhone && <br />}
              {overviewData.SingerUnion && <div>Singer's union:</div>}
              {overviewData.SingerAgency && <div>Singer's agency:</div>}
              {overviewData.SingerAgencyName &&<br />}
              {overviewData.SingerAgencyContactName && <br />}
              {overviewData.SingerAgencyContactEmail && <br/>}
              {overviewData.SingerAgencyContactPhone && <br/>}
            </div>
            <div className="col-8">
              {overviewData.VoiceActorUnion && <div>{overviewData.VoiceActorUnion}</div>}
              {overviewData.VoiceActorAgency && <div>{overviewData.VoiceActorAgency}</div>}
              {overviewData.VoiceActorAgencyContactName && <div>{overviewData.VoiceActorAgencyContactName}</div>}
              {overviewData.VoiceActorAgencyContactEmail && <div><a href={"mailto:" + overviewData.VoiceActorAgencyContactEmail}>{overviewData.VoiceActorAgencyContactEmail}</a></div>}
              {overviewData.VoiceActorAgencyContactPhone && <div>{overviewData.VoiceActorAgencyContactPhone}</div>}
              {overviewData.SingerUnion && <div>{overviewData.SingerUnion}</div>}
              {overviewData.SingerAgency && <div>{overviewData.SingerAgency}</div>}
              {overviewData.SingerAgencyName && <div>{overviewData.SingerAgencyName }</div>}
              {overviewData.SingerAgencyContactName && <div>{overviewData.SingerAgencyContactName}</div>}
              {overviewData.SingerAgencyContactEmail && <div><a href={"mailto" + overviewData.SingerAgencyContactEmail}>{overviewData.SingerAgencyContactEmail}</a></div>}
              {overviewData.SingerAgencyContactPhone && <div>{overviewData.SingerAgencyContactPhone}</div>}
            </div>
          </div>
        </div>
    )
  }
}

export default UnionsAndRepresentationsBox
